<template>
      <div class="text-center ma-2">
    <v-snackbar
      :top='true'
      v-model="snackbar"
    >
      {{ serverMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
         @click="close()"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      text: 'My timeout is set to 2000',
      timeout: 5000,
    }),

    methods: {
      close(){
       let payload = {
                status: false,
                message:""
            }
            this.$store.dispatch('SnackbarFunc', payload)
      }
    },

    computed: {
    snackbar() {
            return this.$store.state.User.snackbar;
          },
    serverMessage() {
            return this.$store.state.User.serverMessage;
    }
    },
     watch: {
      snackbar (val) {
        if (val){
        setTimeout(() =>{this.$store.dispatch('SnackbarFunc', false)}, 10000)
        }
      },
    },

  }
</script>
<style scoped>
.nextBtn{
     background-color: #AD1684 !important;
}
.err{
  width: 100%;
  display: flex;
  justify-items:space-between;
  align-items: space-between;
}
</style>